import {useCodelists} from 'services/codelists';
import {useTableConfig} from 'services/settings/hooks';
import {useThesauruses} from 'services/thesaurus';
import type {SchemaDataAccess} from 'schema/contexts';

/**
 * Concrete implementation of the schema layer's data-access seam, wiring it to
 * the application's Redux-backed codelist, thesaurus and table-settings
 * services. Provided to the schema layer via SchemaDataProvider (see ThemedApp).
 */
export const appSchemaDataAccess: SchemaDataAccess = {
  useCodelists,
  useThesauruses,
  useTableConfig,
};
